// src/components/Utility/PopText.jsx
import React from "react";

export default function PopText({ children, className = "", onClick }) {
  return (
    <div
      onClick={onClick}
      className={`
        inline-block 
        cursor-pointer 
        transition-transform 
        duration-200 
        ease-in-out 
        transform 
        hover:scale-110 
        hover:animate-wiggle 
        ${className}
      `}
    >
      {children}
    </div>
  );
}